import { render, staticRenderFns } from "./IncidentReportPeopleSelector.vue?vue&type=template&id=31afc482&scoped=true"
import script from "./IncidentReportPeopleSelector.vue?vue&type=script&lang=js"
export * from "./IncidentReportPeopleSelector.vue?vue&type=script&lang=js"
import style0 from "./IncidentReportPeopleSelector.vue?vue&type=style&index=0&id=31afc482&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31afc482",
  null
  
)

export default component.exports